export default {
  MONDAY: 'Mon',
  THURSDAY: 'Thu',
  WEDNESDAY: 'Wed',
  TUESDAY: 'Tue',
  FRIDAY: 'Fri',
  SATURDAY: 'Sat',
  SUNDAY: 'Sun',
};
